<template>
    <div id="app">
        <NavBar/>
        <TVNavBar/>
        <router-view/>
        <FooterArea/>
        <svgIcon/>
    </div>
</template>

<script>
    import NavBar from "./components/top";
    import svgIcon from "./components/svgIcon";
    import TVNavBar from "./components/rltvTop";
    import FooterArea from "./components/footer";
    export default {
        name: "App",
        components: {
            svgIcon: svgIcon,
            NavBar: NavBar,
            TVNavBar: TVNavBar,
            FooterArea: FooterArea
        }
    };
</script>

<style>
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue